export default __webpack_public_path__ + "static/bannerPubliMBBO-104bd02084a48a6af117052f547c8873.png";